import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Container } from "react-bootstrap";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";

const EditShgMember = () => {
  const [shgMemberData, setShgMemberData] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;
  useEffect(() => {
    console.log("Received ID:", id); // Debugging
    // Fetch SHG member data using this ID
  }, [id]);
  useEffect(() => {
    setLoading(true);
    const fetchShgMemberById = async () => {
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/shgMember/${id}`, Config);
        if (response.status !== 200) throw new Error("Error fetching member");
        console.log("Fetched data:", response.data);
        setShgMemberData(response.data.shgMembers);
      } catch (error) {
        console.error("Error fetching member", error);
      }
      setLoading(false);
    };
    fetchShgMemberById();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setShgMemberData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const Config = Authorization();
      const response = await axios.put(
        `${Api}/api/shgMember/${id}`,
        Config,
        shgMemberData
      );
      if (response.status !== 200) throw new Error("Error updating member");
      navigate("/dashboard/manage/shg/member");
    } catch (error) {
      console.error("Error updating member", error);
    }
  };

  return (
    <Container>
      <h2>Edit SHG Member</h2>
      {!shgMemberData && loading ? (
        <Preloader loading={loading} />
      ) : (
        <>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formMemberName">
              <Form.Label>
                Member Name<span className="required-asterisk">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="member"
                value={shgMemberData.member?.name || ""}
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="formMemberStatus">
              <Form.Label>
                Status<span className="required-asterisk">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={shgMemberData.status || ""}
                onChange={handleInputChange}
              >
                <option>Select</option>
                <option value="A">Active</option>
                <option value="I">Inactive</option>
                <option value="D">Delete</option>
              </Form.Control>
            </Form.Group>
            <button
              type="submit"
              className="btn btn-outline-primary btn-icon-text mt-3"
            >
              <i className="mdi mdi-file-check btn-icon-prepend"></i>
              Save Changes
            </button>
            <button className="btn btn-light mt-3">Cancel</button>
          </Form>
        </>
      )}
    </Container>
  );
};

export default EditShgMember;
